'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDownload, iconDownloadTag } from '@ni/nimble-components/dist/esm/icons/download';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDownload };
export { iconDownloadTag };
export const NimbleIconDownload = wrap(IconDownload);